import { z } from 'zod';
import type {
  ReviewInboundReceiptComparisonRequest,
  ReviewInboundReceiptComparisonResponse,
} from './review-inbound-receipt-comparison.dto.js';
import { InboundReceiptDetailDtoSchema } from './inbound-receipts-shared.schema.js';

export const ReviewInboundReceiptComparisonRequestSchema: z.ZodType<ReviewInboundReceiptComparisonRequest> =
  z
    .object({
      companyId: z.uuid(),
      receiptId: z.uuid(),
      comparisonNotes: z.string().trim().min(1),
    })
    .strict();

export const ReviewInboundReceiptComparisonResponseSchema: z.ZodType<ReviewInboundReceiptComparisonResponse> =
  z
    .object({
      receipt: InboundReceiptDetailDtoSchema,
    })
    .strict();
